import { createFileRoute, Link } from "@tanstack/react-router";
import { LegalList, LegalPage, LegalSection } from "@/components/legal/LegalPage";

export const Route = createFileRoute("/afiliados")({
  component: AffiliatesRoute,
  head: () => ({
    meta: [
      { title: "Disclosure de afiliados — Sift Trip" },
      {
        name: "description",
        content: "Cómo funcionan los enlaces de afiliado de SiftTrip, comisiones y transparencia con proveedores.",
      },
    ],
  }),
});

function AffiliatesRoute() {
  return (
    <LegalPage title="Disclosure de afiliados" eyebrow="Comisiones y proveedores">
      <LegalSection title="1. Que es un enlace de afiliado">
        <p>
          Cuando ves un boton o enlace para reservar una experiencia en
          SiftTrip, ese enlace suele incluir un parametro de afiliado que
          identifica que la visita vino de SiftTrip. Si completas una reserva
          con ese proveedor, SiftTrip puede recibir una comision — el enlace
          en si no cobra nada ni cambia el proceso de reserva del proveedor.
        </p>
      </LegalSection>

      <LegalSection title="2. Comisiones">
        <p>
          SiftTrip puede participar en programas de afiliados o acuerdos de
          referidos con proveedores de experiencias, tours, actividades,
          free-tours, traslados u otros servicios de viaje. Si reservas despues
          de hacer clic en determinados enlaces, SiftTrip puede recibir una
          comision o compensacion.
        </p>
      </LegalSection>

      <LegalSection title="3. Precio para el usuario">
        <p>
          Usar un enlace de SiftTrip no deberia aumentar el precio que paga el
          usuario, salvo que el proveedor indique expresamente lo contrario. La
          existencia de una comision no significa necesariamente que el
          usuario pague mas, ni garantiza que el precio sea el mas bajo. El
          precio final, disponibilidad, impuestos, cargos, cancelaciones y
          condiciones se confirman en el proveedor que procesa la reserva —
          esas condiciones finales son siempre del proveedor, no de SiftTrip.
        </p>
      </LegalSection>

      <LegalSection title="4. Ranking y comparacion">
        <p>
          SiftTrip busca ordenar resultados por relevancia, disponibilidad,
          calidad, informacion del proveedor, preferencias del usuario y senales
          del producto. Una relacion de afiliado no debe entenderse como una
          garantia de calidad ni como recomendacion personalizada definitiva.
        </p>
        <p>
          Salvo que se indique lo contrario, ninguna posicion en los resultados
          esta patrocinada ni fue pagada por un proveedor. Si en el futuro
          existe contenido patrocinado, pago por posicion o una regla que
          altere el orden por compensacion comercial, debera indicarse
          claramente cerca del resultado correspondiente.
        </p>
      </LegalSection>

      <LegalSection title="5. Proveedores externos">
        <LegalList
          items={[
            "Viator, GuruWalk u otros proveedores pueden tener sus propias condiciones, politicas de privacidad y reglas de reserva.",
            "SiftTrip no controla la ejecucion final de servicios externos salvo que se indique expresamente lo contrario.",
            "Los enlaces pueden incluir parametros de referencia o afiliado para atribucion.",
          ]}
        />
      </LegalSection>

      <LegalSection title="6. Donde aparece este aviso">
        <p>
          Este aviso complementa los{" "}
          <Link to="/terminos" className="font-semibold text-[#E8194B]">
            terminos y condiciones
          </Link>{" "}
          y deberia acompanarse de avisos visibles cerca de botones o enlaces de
          reserva cuando sea razonable. Para preguntas sobre comisiones o
          alianzas, escribe a{" "}
          <a href="mailto:contact@siftrip.com" className="font-semibold text-[#E8194B]">
            contact@siftrip.com
          </a>
          .
        </p>
      </LegalSection>
    </LegalPage>
  );
}
